import { breakpoints } from './breakpoints';
import { colors } from './colors';
import { Theme } from './theme.types';

export const theme: Theme = {
    colors,
    breakpoints,
    fonts: ['Calibri', 'Helvetica', 'Arial', 'sans-serif'],
};
